export const SET_USER_INFO = 'PRO/SET_USER_INFO'
export type SET_USER_INFO = typeof SET_USER_INFO

export const CLEAR_USER_INFO = 'PRO/CLEAR_USER_INFO'
export type CLEAR_USER_INFO = typeof CLEAR_USER_INFO
